import { render, staticRenderFns } from "./joinNav.vue?vue&type=template&id=9610e4e8"
import script from "./joinNav.vue?vue&type=script&lang=js"
export * from "./joinNav.vue?vue&type=script&lang=js"
import style0 from "./joinNav.vue?vue&type=style&index=0&id=9610e4e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports